import Alpine from 'alpinejs';

Alpine.data('accordion', (behavior) => ({
  openItems: [],

  toggle(index) {
    const wasOpen = this.openItems.includes(index);

    if (behavior === 'single') {
      this.openItems = wasOpen ? [] : [index];
    } else {
      if (wasOpen) {
        this.openItems = this.openItems.filter(i => i !== index);
      } else {
        this.openItems.push(index);
      }
    }

    // Move focus to body content when opening
    if (!wasOpen) {
      this.$nextTick(() => {
        const bodyEl = document.getElementById(`accordion-body-${index}`);
        if (bodyEl) {
          bodyEl.focus();
        }
      });
    }
  },

  isOpen(index) {
    return this.openItems.includes(index);
  }
}));